/**
 * Constants related to entities across the application
 */

/**
 * Maximum allowed length for entity long titles across the application
 * Applies to (e.g., spaces, events)
 */
export const MAX_ENTITY_LONG_TITLE_LENGTH = 250;

/**
 * Maximum allowed length for entity short titles across the application
 * Applies to (e.g., programs, cohorts, user names, etc.)
 */
export const MAX_ENTITY_SHORT_TITLE_LENGTH = 100;

/**
 * Maximum allowed default length for entity titles across the application
 */
export const MAX_ENTITY_TITLE_LENGTH = MAX_ENTITY_SHORT_TITLE_LENGTH;

/**
 * Maximum allowed length for generic entity fields across the application
 */
export const MAX_ENTITY_GENERIC_FIELD_LENGTH = 100;
